// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.



const deploymentEnvironment = "PROD";  //chnage only enviroment name ,When you are going to deploy
export const environment: any = getEnvironment(deploymentEnvironment);

function getEnvironment(deploymentEnvironment: string): any {
  if (deploymentEnvironment === "UAT") {
    return {
      production: false,
      //apiUrl: 'https://localhost:5001/api',
      apiUrl: 'http://noatdc-bcswb912:61102/api',
      appId: 'KD',
      imageBaseUrl: 'https://www.kawneer-ecommerce-dev.com/aappsfapi/',
      imageFolder: 'ResourceCenter/assets/itemCatalog/',
      imageUrl: 'https://www.kawneer-ecommerce-dev.com/aappsfapi',
      maxCartQuoteItemCount: 99,
    };
  }
  else if (deploymentEnvironment === "DEV") {
    return {
      production: false,     
      apiUrl: 'http://NOATDC-BCSWB912:4082/api',
      appId: 'KD',
      imageBaseUrl: 'http://NOATDC-BCSWB912:8084/', //veified
      imageFolder: 'assets/itemCatalog/',         //veified
      imageUrl: 'http://NOATDC-BCSWB912:5082',
      maxCartQuoteItemCount: 99,
    };
  }
  else if (deploymentEnvironment === "QA") {
    return {
      production: false,
      //apiUrl: 'https://localhost:5001/api',
      apiUrl: 'https://noatdc-dweb915:13102/api',
      appId: 'KD',
      imageBaseUrl: 'https://noatdc-dweb915:13102/api/',
      imageFolder: 'ResourceCenter/assets/itemCatalog/',
      imageUrl: 'https://noatdc-dweb915:13102/api',
      maxCartQuoteItemCount: 99,
      rynohubapiUrl: 'https://noatdc-bcswb905:15431/api',
    };

  }
  else if (deploymentEnvironment === "PROD") {
    return {
      production: true,
      apiUrl: 'https://www.kawneer-ecommerce.com/aappsfapi/api',
      appId: 'KD',
      imageBaseUrl: 'https://reynohub.com/',
      imageFolder: 'ResourceCenter/assets/itemCatalog/',
      imageUrl: 'https://reynohub.com/ipa',
      maxCartQuoteItemCount: 99,
      rynohubapiUrl: 'https://reynohub.com/ipa/api',
    };
  }
  else if (deploymentEnvironment === "PWA_UAT") {
    return {
      production: true,
      apiUrl: 'https://www.kawneer-ecommerce-dev.com/aappsfapi/api',
      appId: 'KD',
      imageBaseUrl: 'https://www.kawneer-ecommerce-dev.com/aappsfapi/',
      imageFolder: 'ResourceCenter/assets/itemCatalog/',
      imageUrl: 'https://www.kawneer-ecommerce-dev.com/aappsfapi',
      maxCartQuoteItemCount: 99,
    };
  }
  else if (deploymentEnvironment === "PWA_INTERNAL_UAT") {
    return {
      production: false,
      //apiUrl: 'https://localhost:5001/api',
      apiUrl: 'https://noatdc-dweb915:1102/api',
      appId: 'KD',
      imageBaseUrl: 'https://noatdc-dweb915:1104/', //veified
      imageFolder: 'assets/itemCatalog/',         //veified
      imageUrl: 'https://noatdc-dweb915:1102',
      maxCartQuoteItemCount: 99,
    };
  }
  else { //local
    return {
      production: false,
      apiUrl: 'https://localhost:44356/api',
      //apiUrl: 'http://NOATDC-BCSWB912:4082/api',
      appId: 'KD',
      imageBaseUrl: 'https://www.kawneer-ecommerce-dev.com/aappsfapi/',
      imageFolder: 'ResourceCenter/assets/itemCatalog/',
      imageUrl: 'https://www.kawneer-ecommerce-dev.com/aappsfapi',
      maxCartQuoteItemCount: 99,
      rynohubapiUrl: 'https://localhost:44338/api',
    };
  }

}


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
